import { GridFields } from 'components';
import { getYesOrNoOptions } from 'helpers';
import { useStableKeys } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { DocumentsTableFeature } from 'modules/client/common/feature';
import {
  useFormContext,
  Field,
} from 'modules/client/legal/forms/companyLicenseForm';
import { YesOrNoType } from 'types/yesOrNo';

import { Header, Fields } from './components';

interface FormContentProps {
  onRemove: (index: number) => void;
}

export const FormContent = ({ onRemove }: FormContentProps) => {
  const { t } = useTranslation();
  const { values, readOnly } = useFormContext();

  const licensesKeys = useStableKeys(values.companyLicense.licenses);

  return (
    <>
      {values.companyLicense.licenses.map((_, index) => (
        <Stack key={licensesKeys[index]} spacing={24}>
          <Stack spacing={12}>
            <Header index={index} readOnly={readOnly} onRemove={onRemove} />
            <GridFields>
              {index === 0 && (
                <Field.Autocomplete
                  fullWidth
                  showRequiredMark
                  label={t(
                    'client.legal.companyLicense.companyActivityIsLicensed.label'
                  )}
                  name="companyLicense.companyActivityIsLicensed"
                  optionLabelKey="label"
                  options={getYesOrNoOptions(t)}
                  optionValueKey="value"
                  placeholder={t(
                    'client.legal.companyLicense.companyActivityIsLicensed.placeholder'
                  )}
                  variant="select"
                />
              )}
              {values.companyLicense.companyActivityIsLicensed &&
                values.companyLicense.companyActivityIsLicensed.value ===
                  YesOrNoType.Yes && <Fields index={index} />}
            </GridFields>
          </Stack>
          {values.companyLicense.companyActivityIsLicensed &&
            values.companyLicense.companyActivityIsLicensed.value ===
              YesOrNoType.Yes && (
              <DocumentsTableFeature
                name={`companyLicense.licenses.${index}.files`}
                readOnly={readOnly}
              />
            )}
        </Stack>
      ))}
    </>
  );
};
